export const getSSRDocument = () => {
  return typeof document !== 'undefined' ? document : null
}
